import React from 'react';

const AuthContext = React.createContext<any>({
    AuthLink: 'Registration',
    setAuthLink: (AuthLink: 'Registration') => {
        console.log(AuthLink);
    },
});
export { AuthContext };
